module.exports = __webpack_public_path__ + "static/img/3.3887094.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/dice/3.png
// module id = XmS/
// module chunks = 2